import Vue from "vue";
import Router from "vue-router";
import Service from "./services";
import store from "./store/store.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "/",
      component: () => import("./layouts/main/Main.vue"),
      redirect: {
        name: "dash"
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/dash",
          name: "dash",
          component: () => import("./views/Home.vue"),
          meta: {
            pageTitle: "Dashboard",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/redirect",
          name: "redirect",
          component: () => import("./views/Redirect.vue"),
          meta: {
            pageTitle: "Loading...",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/orders",
          name: "order-list",
          component: () => import("@/views/pages/order/List.vue"),
          meta: {
            // pageTitle: "Orders",
            pageTitle: "Registrations",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/orders/:id",
          name: "order-detail",
          component: () => import("@/views/pages/order/Detail.vue"),
          meta: {
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/tickets",
          name: "ticket-list",
          component: () => import("@/views/pages/ticket/List.vue"),
          meta: {
            pageTitle: "Tickets",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/tickets/:id",
          name: "ticket-detail",
          component: () => import("@/views/pages/ticket/Detail.vue"),
          meta: {
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/promocodes",
          name: "promocodes-list",
          component: () => import("@/views/pages/promocode/List.vue"),
          meta: {
            pageTitle: "Promo codes",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/promocodes/:promocode_id/view",
          name: "promocodes-detail",
          props: true,
          component: () => import("@/views/pages/promocode/Detail.vue"),
          meta: {
            pageTitle: "Edit Promo Code",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/promocodes/add",
          name: "promocodes-add",
          component: () => import("@/views/pages/promocode/Add.vue"),
          props: true,
          meta: {
            pageTitle: "Add New Promo code",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/promotions",
          name: "promotions-list",
          component: () => import("@/views/pages/promotion/List.vue"),
          meta: {
            pageTitle: "Promotions",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/promotions/:promocode_id/view",
          name: "promotions-detail",
          props: true,
          component: () => import("@/views/pages/promotion/Detail.vue"),
          meta: {
            pageTitle: "Edit Promotion",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/promotions/add",
          name: "promotions-add",
          component: () => import("@/views/pages/promotion/Add.vue"),
          props: true,
          meta: {
            pageTitle: "Add New Promotion",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/saletriggers",
          name: "saletriggers-list",
          component: () => import("@/views/pages/saletriggers/List.vue"),
          meta: {
            pageTitle: "Special Links",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/saletriggers/:promocode_id/view",
          name: "saletriggers-detail",
          props: true,
          component: () => import("@/views/pages/saletriggers/Detail.vue"),
          meta: {
            pageTitle: "Special Link Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/saletriggers-promo/:promocode_id/view",
          name: "saletriggers-promo-detail",
          props: true,
          component: () => import("@/views/pages/saletriggers/Detail.vue"),
          meta: {
            pageTitle: "Edit Promotion",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/saletriggers/add",
          name: "saletriggers-add",
          component: () => import("@/views/pages/saletriggers/Add.vue"),
          props: true,
          meta: {
            pageTitle: "Add New Special Link",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/saletriggers/add-promo",
          name: "saletriggers-add",
          component: () => import("@/views/pages/saletriggers/Add.vue"),
          props: true,
          meta: {
            pageTitle: "Add New Promotion",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/special-links",
          name: "special-links-list",
          component: () => import("@/views/pages/special-links/List.vue"),
          meta: {
            pageTitle: "Special Links",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/special-links/:promocode_id/view",
          name: "special-links-detail",
          props: true,
          component: () => import("@/views/pages/special-links/Detail.vue"),
          meta: {
            pageTitle: "Edit Special Link",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/special-links-promo/:promocode_id/view",
          name: "special-links-promo-detail",
          props: true,
          component: () => import("@/views/pages/special-links/Detail.vue"),
          meta: {
            pageTitle: "Promotion Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/special-links/add",
          name: "special-links-add",
          component: () => import("@/views/pages/special-links/Add.vue"),
          props: true,
          meta: {
            pageTitle: "Add New Special Link",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/special-links/add-promo",
          name: "special-links-add",
          component: () => import("@/views/pages/special-links/Add.vue"),
          props: true,
          meta: {
            pageTitle: "Add New Promotion",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/merchants",
          name: "merchant-list",
          component: () => import("@/views/pages/merchant/List.vue"),
          meta: {
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/events",
          name: "event-list",
          component: () => import("@/views/pages/event/List.vue"),
          meta: {
            pageTitle: "All Events",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/events/add",
          name: "event-add",
          component: () => import("@/views/pages/event/Add.vue"),
          meta: {
            pageTitle: "Add new Event",
            requiresAuth: true,
            requiredQuery: []
          }
        },
        {
          path: "/events/addquick",
          name: "event-add-quick",
          component: () => import("@/views/pages/event/AddQuick.vue"),
          meta: {
            pageTitle: "Add new Event",
            requiresAuth: true,
            requiredQuery: []
          }
        },
        {
          path: "/events/addfirst/:sid",
          name: "event-add",
          component: () => import("@/views/pages/event/AddFirst.vue"),
          meta: {
            pageTitle: "Add First Event",
            requiresAuth: true,
            requiredQuery: []
          }
        },
        {
          path: "/events/:folder/view",
          name: "event-detail",
          component: () => import("@/views/pages/event/Detail2.vue"),
          props: true,
          meta: {
            pageTitle: "Edit Info",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/events/:folder/detail",
          name: "event-detail-view",
          component: () => import("@/views/pages/event/DetailView.vue"),
          props: true,
          meta: {
            pageTitle: "Event Info",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/events/:folder/attendee_messages",
          name: "attendee_messages-list",
          component: () => import("@/views/pages/attendee_messages/List.vue"),
          meta: {
            pageTitle: "Attendee Messages",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/events/:folder/attendee_messages/add",
          name: "attendee_messages-add",
          component: () => import("@/views/pages/attendee_messages/Add.vue"),
          meta: {
            pageTitle: "Add new Attendee Message",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/events/:folder/attendee_messages/:message_id/view",
          name: "attendee_messages-edit",
          component: () => import("@/views/pages/attendee_messages/Detail.vue"),
          meta: {
            pageTitle: "Edit Attendee Message",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences",
          name: "conferences-list",
          component: () => import("@/views/pages/conference/Dashboard.vue"),
          meta: {
            pageTitle: "Conference Dashboard",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/sessions",
          name: "session-list",
          component: () =>
            import("@/views/pages/conference/Sessions/Index.vue"),
          meta: {
            pageTitle: "Session List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
            /*
            breadcrumb:[
            {
              title: 'Sessions',
              url: 'conferences/session',
              active: true
            },
           ]
           */
          }
        },
        {
          path: "/conferences/sessions/add",
          name: "session-add",
          component: () => import("@/views/pages/conference/Sessions/Add.vue"),
          meta: {
            pageTitle: "New Event Session",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
            /*
            breadcrumb:[
            {
              title: 'Sessions',
              url: 'conferences/session',
              active: true
            },
            {
              title: 'Add Sessions',
              url: 'conferences/session/add',
              active: true
            },
           ]*/
          }
        },
        {
          path: "/conferences/sessions/:slug/view",
          name: "session-detail",
          props: true,
          component: () =>
            import("@/views/pages/conference/Sessions/Detail.vue"),
          meta: {
            pageTitle: "Session Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        // {
        //   path: "/videos",
        //   name: "video-event-list",
        //   component: () =>
        //     import("@/views/pages/conference/VideoEvents/Index.vue"),
        //   meta: {
        //     pageTitle: "Video List",
        //     requiresAuth: true,
        //     requiredQuery: ["s", "e"],
        //     /*
        //     breadcrumb:[
        //     {
        //       title: 'VideoEvents',
        //       url: 'conferences/video-event',
        //       active: true
        //     },
        //    ]
        //    */
        //   },
        // },
        // {
        //   path: "/videos/add",
        //   name: "video-event-add",
        //   component: () => import("@/views/pages/conference/VideoEvents/Add.vue"),
        //   meta: {
        //     pageTitle: "New Video",
        //     requiresAuth: true,
        //     requiredQuery: ["s", "e"],
        //     /*
        //     breadcrumb:[
        //     {
        //       title: 'VideoEvents',
        //       url: 'conferences/video-event',
        //       active: true
        //     },
        //     {
        //       title: 'Add VideoEvents',
        //       url: 'conferences/video-event/add',
        //       active: true
        //     },
        //    ]*/
        //   },
        // },
        // {
        //   path: "/videos/:slug/view",
        //   name: "video-event-detail",
        //   props: true,
        //   component: () =>
        //     import("@/views/pages/conference/VideoEvents/Detail.vue"),
        //   meta: {
        //     pageTitle: "Video Detail",
        //     requiresAuth: true,
        //     requiredQuery: ["s", "e"],
        //   },
        // },
        {
          path: "/videos",
          name: "merchant-video-list",
          component: () =>
            import("@/views/pages/merchant_video/Index.vue"),
          meta: {
            pageTitle: "Video List",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
            /*
            breadcrumb:[
            {
              title: 'VideoEvents',
              url: 'conferences/video-event',
              active: true
            },
           ]
           */
          },
        },
        {
          path: "/videos/add",
          name: "merchant-videos-add",
          component: () => import("@/views/pages/merchant_video/Add.vue"),
          meta: {
            pageTitle: "New Video",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
            /*
            breadcrumb:[
            {
              title: 'VideoEvents',
              url: 'conferences/video-event',
              active: true
            },
            {
              title: 'Add VideoEvents',
              url: 'conferences/video-event/add',
              active: true
            },
           ]*/
          },
        },
        {
          path: "/videos/:video_id/view",
          name: "merchant-videos-detail",
          props: true,
          component: () =>
            import("@/views/pages/merchant_video/Detail.vue"),
          meta: {
            pageTitle: "Video Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/speakers",
          name: "speakers-list",
          component: () =>
            import("@/views/pages/speakers/Index.vue"),
          meta: {
            pageTitle: "Speaker List",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
            /*
            breadcrumb:[
            {
              title: 'VideoEvents',
              url: 'conferences/video-event',
              active: true
            },
           ]
           */
          },
        },
        {
          path: "/speakers/add",
          name: "speakers-add",
          component: () => import("@/views/pages/speakers/Add.vue"),
          meta: {
            pageTitle: "New Speaker",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/speakers/:speaker_id/view",
          name: "speakers-detail",
          props: true,
          component: () =>
            import("@/views/pages/speakers/Detail.vue"),
          meta: {
            pageTitle: "Speaker Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/conferences/auctions",
          name: "auction-list",
          component: () =>
            import("@/views/pages/conference/Auctions/Index.vue"),
          meta: {
            pageTitle: "Auction List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/auctions/:id/view",
          name: "auction-detail",
          props: true,
          component: () =>
            import("@/views/pages/conference/Auctions/Detail.vue"),
          meta: {
            pageTitle: "Auction Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/livestreams",
          name: "live-list",
          component: () => import("@/views/pages/conference/Live/Index.vue"),
          meta: {
            pageTitle: "Live Stream List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/speakers",
          name: "speaker-list",
          component: () =>
            import("@/views/pages/conference/Speakers/Index.vue"),
          meta: {
            pageTitle: "Speaker List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/speakers/add",
          name: "speaker-add",
          component: () => import("@/views/pages/conference/Speakers/Add.vue"),
          meta: {
            pageTitle: "Add new Speaker",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/speakers/:id/view",
          name: "speaker-detail",
          component: () =>
            import("@/views/pages/conference/Speakers/Detail.vue"),
          props: true,
          meta: {
            pageTitle: "Speaker Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/sponsors",
          name: "sponsor-list",
          component: () =>
            import("@/views/pages/conference/Sponsors/Index.vue"),
          meta: {
            pageTitle: "Sponsor List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/sponsors/add",
          name: "sponsor-add",
          component: () => import("@/views/pages/conference/Sponsors/Add.vue"),
          meta: {
            pageTitle: "Add new Sponsor",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/sponsors/:id/view",
          name: "sponsor-detail",
          component: () =>
            import("@/views/pages/conference/Sponsors/Detail.vue"),
          props: true,
          meta: {
            pageTitle: "Sponsor Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/companies",
          name: "company-list",
          component: () => import("@/views/pages/conference/Companies.vue"),
          meta: {
            pageTitle: "Company List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/booths",
          name: "booth-list",
          component: () => import("@/views/pages/conference/Booths/Index.vue"),
          meta: {
            pageTitle: "Booths List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/booths/add",
          name: "booth-add",
          component: () => import("@/views/pages/conference/Booths/Add.vue"),
          meta: {
            pageTitle: "Add new Booth",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/booths/:id/view",
          name: "booth-detail",
          component: () => import("@/views/pages/conference/Booths/Detail.vue"),
          props: true,
          meta: {
            pageTitle: "Booth Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/attendees",
          name: "attendee-list",
          component: () =>
            import("@/views/pages/conference/Attendees/Index.vue"),
          meta: {
            pageTitle: "Attendee List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/attendees/:id/view",
          name: "attendee-detail",
          component: () =>
            import("@/views/pages/conference/Attendees/Detail.vue"),
          props: true,
          meta: {
            pageTitle: "Attendee Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/filters",
          name: "filter-list",
          component: () => import("@/views/pages/conference/Filter/Index.vue"),
          meta: {
            pageTitle: "All Filters",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/filters/add",
          name: "filter-add",
          component: () => import("@/views/pages/conference/Filter/Add.vue"),
          meta: {
            pageTitle: "Add new Filter",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/filters/:id/view",
          name: "filter-detail",
          component: () => import("@/views/pages/conference/Filter/Detail.vue"),
          props: true,
          meta: {
            pageTitle: "Filter Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/conferences/engagements",
          name: "engagament-list",
          component: () =>
            import("@/views/pages/conference/Engagements/Index.vue"),
          meta: {
            pageTitle: "Engagement List",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/overview",
          name: "report-overview",
          component: () => import("@/views/pages/report/Overview.vue"),
          meta: {
            pageTitle: "Overview",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/referrer",
          name: "report-referrer",
          component: () => import("@/views/pages/report/Referrer.vue"),
          meta: {
            pageTitle: "Performance by Referrer",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/attendee-info",
          name: "report-attendee-info",
          component: () => import("@/views/pages/report/AttendeeInfo.vue"),
          meta: {
            pageTitle: "Attendee Info",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/rsvp",
          name: "report-rsvp",
          component: () => import("@/views/pages/report/Rsvp.vue"),
          meta: {
            pageTitle: "RSVP by Focal Point",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/register-focalpoint",
          name: "report-registration-focalpoint",
          component: () =>
            import("@/views/pages/report/RegisterFocalPoint.vue"),
          meta: {
            pageTitle: "Registration by Focal Point",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/registration",
          name: "report-register",
          component: () => import("@/views/pages/report/Register.vue"),
          meta: {
            pageTitle: "Registration",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/promocode",
          name: "report-promocode",
          component: () => import("@/views/pages/report/Promocode.vue"),
          meta: {
            pageTitle: "Performance by Promo Codes",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/ticket",
          name: "report-ticket",
          component: () => import("@/views/pages/report/Ticket.vue"),
          meta: {
            pageTitle: "Ticket Summary",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/campaign",
          name: "report-campaign",
          component: () => import("@/views/pages/report/Campaign.vue"),
          meta: {
            pageTitle: "Performance by Campaign",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/content",
          name: "report-content",
          component: () => import("@/views/pages/report/Content.vue"),
          meta: {
            pageTitle: "Performance by Content",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/source",
          name: "report-source",
          component: () => import("@/views/pages/report/Source.vue"),
          meta: {
            pageTitle: "Performance by Source/Medium",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/sales",
          name: "report-sales",
          component: () => import("@/views/pages/report/Sales.vue"),
          meta: {
            pageTitle: "Sale Report",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/communication",
          name: "report-communication",
          component: () => import("@/views/pages/report/Communication.vue"),
          meta: {
            pageTitle: "Communication Report",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/report/checkin-detail",
          name: "report-checkin-detail",
          component: () => import("@/views/pages/report/CheckinDetail.vue"),
          meta: {
            pageTitle: "Checkin Report",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/voting/responses",
          name: "voting-responses",
          component: () => import("@/views/pages/report/Vote.vue"),
          meta: {
            pageTitle: "All Responses",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/voting/responses-voter",
          name: "voting-responses-voter",
          component: () =>
            import("@/views/pages/report/VoteResponseTicket.vue"),
          meta: {
            pageTitle: "Responses by Voter",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/voting/summary",
          name: "vote-summary",
          component: () => import("@/views/pages/report/VoteSummary.vue"),
          meta: {
            pageTitle: "Vote Summary",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/voting/summary-candidate",
          name: "vote-summary",
          component: () =>
            import("@/views/pages/report/VoteSummaryCandidate.vue"),
          meta: {
            pageTitle: "Vote Summary Candidate",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/accounting/overview",
          name: "accounting-overview",
          component: () => import("@/views/pages/accounting/Overview.vue"),
          meta: {
            pageTitle: "Accounting - Overview",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/accounting/orders",
          name: "accounting-orders",
          component: () => import("@/views/pages/accounting/Orders.vue"),
          meta: {
            pageTitle: "Accounting - Orders",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/accounting/taxinvoices",
          name: "accounting-taxinvoices",
          component: () => import("@/views/pages/accounting/TaxInvoices.vue"),
          meta: {
            pageTitle: "Accounting - Tax Invoices",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/users",
          name: "users",
          component: () => import("@/views/pages/user/List.vue"),
          meta: {
            pageTitle: "Users",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/users/invite",
          name: "users-invite",
          component: () => import("@/views/pages/user/Invite.vue"),
          meta: {
            pageTitle: "Invite User",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/users/:id/view",
          name: "user-detail",
          component: () => import("@/views/pages/user/Detail.vue"),
          props: true,
          meta: {
            pageTitle: "User Detail",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/views/pages/user/Profile.vue"),
          meta: {
            pageTitle: "My Profile",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/checkin",
          name: "checkin",
          component: () => import("@/views/pages/checkin/Index.vue"),
          meta: {
            pageTitle: "Checkin",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/checkin/monitor",
          name: "checkin-monitor",
          component: () => import("@/views/pages/checkin/Monitor.vue"),
          meta: {
            pageTitle: "Checkin Monitor",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/checkin/report-group",
          name: "checkin-attendee",
          component: () => import("@/views/pages/checkin/Attendee.vue"),
          meta: {
            pageTitle: "Check-in by Attendee",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/checkin/report-day",
          name: "checkin-day",
          component: () => import("@/views/pages/checkin/Day.vue"),
          meta: {
            pageTitle: "Check-in by Day",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/upsells",
          name: "upsell",
          component: () => import("@/views/pages/upsell/List.vue"),
          meta: {
            pageTitle: "Upsells",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/upsells/new",
          name: "upsell-new",
          component: () => import("@/views/pages/upsell/Add.vue"),
          meta: {
            pageTitle: "New Upsell",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/upsells/:upsell_id/view",
          name: "upsell-detail",
          props: true,
          component: () => import("@/views/pages/upsell/Detail.vue"),
          meta: {
            pageTitle: "Edit Upsell",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/forms",
          name: "forms",
          component: () => import("@/views/pages/question/List.vue"),
          meta: {
            pageTitle: "Forms",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/forms/add",
          name: "form-add",
          component: () => import("@/views/pages/question/Add.vue"),
          meta: {
            pageTitle: "Add New Form",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/forms/:form_id",
          name: "form-detail",
          props: true,
          component: () => import("@/views/pages/question/Detail.vue"),
          meta: {
            pageTitle: "Form Detail - Questions",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/pages",
          name: "pages",
          component: () => import("@/views/pages/pages/List.vue"),
          meta: {
            pageTitle: "Page List",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages/add",
          name: "pages-add",
          component: () => import("@/views/pages/pages/Add.vue"),
          meta: {
            pageTitle: "Add New Page",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages/:page_id",
          name: "pages-detail",
          props: true,
          component: () => import("@/views/pages/pages/Detail.vue"),
          meta: {
            pageTitle: "Page Contents",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/pages",
          name: "pages",
          component: () => import("@/views/pages/pages/List.vue"),
          meta: {
            pageTitle: "Page List",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages/add",
          name: "pages-add",
          component: () => import("@/views/pages/pages/Add.vue"),
          meta: {
            pageTitle: "Add New Page",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages/:page_id",
          name: "pages-detail",
          props: true,
          component: () => import("@/views/pages/pages/Detail.vue"),
          meta: {
            pageTitle: "Page Contents",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages",
          name: "pages",
          component: () => import("@/views/pages/pages/List.vue"),
          meta: {
            pageTitle: "Page List",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages/add",
          name: "pages-add",
          component: () => import("@/views/pages/pages/Add.vue"),
          meta: {
            pageTitle: "Add New Page",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/pages/:page_id",
          name: "pages-detail",
          props: true,
          component: () => import("@/views/pages/pages/Detail.vue"),
          meta: {
            pageTitle: "Page Contents",
            requiresAuth: true,
            requiredQuery: ["s", "e"],
          },
        },
        {
          path: "/settings/profile",
          name: "profile",
          component: () => import("@/views/pages/settings/Profile.vue"),
          meta: {
            pageTitle: "My Profile",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/settings/edit-merchant",
          name: "edit-merchant",
          component: () => import("@/views/pages/settings/Merchant.vue"),
          meta: {
            pageTitle: "Edit Merchant Info",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/settings/add",
          name: "add-merchant",
          component: () => import("@/views/pages/settings/AddMerchant.vue"),
          meta: {
            pageTitle: "Add New Seller",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        // {
        //   path: "/events",
        //   name: "event-list",
        //   component: () => import("@/views/pages/event/List.vue"),
        //   meta: {
        //     pageTitle: "All Events",
        //     requiresAuth: true,
        //     requiredQuery: ["s", "e"]
        //   }
        // },
        {
          path: "/sellers",
          name: "seller-list",
          component: () => import("@/views/pages/seller/List.vue"),
          meta: {
            pageTitle: "All Sellers",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        },
        {
          path: "/sellers/:merchant_id/view",
          name: "edit-merchant",
          component: () => import("@/views/pages/seller/Merchant.vue"),
          meta: {
            pageTitle: "Edit Merchant Info",
            requiresAuth: true,
            requiredQuery: ["s", "e"]
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/register",
          name: "page-register",
          component: () => import("@/views/pages/Register.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/profile/selectAssets",
          name: "profile-selecteAssets",
          component: () => import("@/views/pages/user/SelectAssets.vue"),
          meta: {
            pageTitle: "Select Assets",
            requiresAuth: true
          }
        },
        {
          path: "/onboarding",
          name: "page-onboarding-1",
          component: () => import("@/views/pages/onboarding/index.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/onboarding/create-seller",
          name: "page-onboarding-2",
          component: () => import("@/views/pages/onboarding/create-seller.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/onboarding/create-event/:merchant_id",
          name: "page-onboarding-3",
          component: () => import("@/views/pages/onboarding/create-event.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/terms",
          name: "terms",
          component: () => import("@/views/pages/terms.vue"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  let q = Object.keys(to.query)
    .map(key => key + "=" + to.query[key])
    .join("&");
  // let q = Object.keys(to.query)
  //   .map((key) => key + "=" + to.query[key])
  //   .join("&");

  setTimeout(() => {
    //console.log(localStorage.getItem("soldoutt-nimda"))
    if (!localStorage.getItem("soldoutt-nimda")) {
      next({
        path: "/login",
        params: {
          nextUrl: to.fullPath
        }
      });
    } else if (localStorage.getItem("soldoutt-nimda") === null) {
      next();
    } else {
      if (
        to.path == "/login" ||
        to.path == "/register" ||
        to.path == "/pages/error-404"
      ) {
        next();
        return;
      }

      let vuex = JSON.parse(localStorage.getItem("soldoutt-nimda"));
      let accessToken = vuex.Auth.accessToken;
      let current_s = vuex.Utility.s;
      let current_e = vuex.Utility.e;
      let query = {};
      let forceQuery = false;
      query.s = current_s;
      query.e = current_e;

      if (accessToken == null) {
        const urlParams = new URLSearchParams(window.location.search);
        let redirect = urlParams.get("redirectURL");
        if (redirect === "checkin") {
          next({
            path: "/login?redirectURL=checkin",
            params: {
              nextUrl: to.fullPath
            }
          });
        }

        next({
          path: "/login",
          params: {
            nextUrl: to.fullPath
          }
        });
      }

      if (to.path == "/checkin") {
        Service.Auth.getCheckinToken()
          .then(res => {
            if (!res.success) window.location.href = "/";
            window.open(
              "https://ascriptlab.com/soldd-out?token=" + res.redirect_token,
              "_blank"
            );
          })
          .catch(() => {
            next({
              path: "/login?redirectURL=checkin",
              params: {
                nextUrl: to.fullPath
              }
            });
          });
        return;
      }

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let redirect = urlParams.get("redirectURL");
      if (redirect === "checkin") {
        Service.Auth.getCheckinToken()
          .then(res => {
            if (!res.success) window.location.href = "/";
            window.location.href =
              "https://ascriptlab.com/soldd-out?token=" + res.redirect_token;
          })
          .catch(() => {
            next({
              path: "/login?redirectURL=checkin",
              params: {
                nextUrl: to.fullPath
              }
            });
          });
        return;
      }

      Service.Auth.getUser()
        .then(res => {
          store.commit("Auth/SET_USER", res.data);
          // eslint-disable-next-line no-undef
          try {
            // eslint-disable-next-line no-undef
            $crisp.push(["set", "user:email", [res.data.info.email]]);
            // eslint-disable-next-line no-empty
          } catch (e) {}
          if (res.data.info.consent_at == null) {
            next({
              path: "/terms"
            });
            return;
          }
          if (res.data.default.s == null || res.data.default.e == null) {
            next({
              path: "/profile/selectAssets"
            });
          }

          if (to.meta.requiredQuery) {
            if (to.meta.requiredQuery.includes("s")) {
              if (!to.query.s) {
                query.s = current_s;
                forceQuery = true;
              }
            }
            if (to.meta.requiredQuery.includes("e")) {
              if (!to.query.e) {
                query.e = current_e;
                forceQuery = true;
              }
            }
            if (forceQuery) {
              let clone = null;
              if (to.query.clone) {
                clone = { clone: to.query.clone };
              }
              next({ path: to.path, query: { ...query, ...clone } });
            } else {
              next();
            }
          } else {
            next();
          }
        })
        .catch(error => {
          let params = "";
          let inactive = false;
          if (error && error.message) {
            inactive =
              error.message ==
              "Account is not active. This may be due to inactivity. Please contact support for assistance."
                ? 1
                : 0;
          }
          if (inactive) {
            params += "inactive=1";
          }
          if (params) {
            params = "?" + params;
          }
          next({
            path: "/login" + params,
            params: {
              nextUrl: to.fullPath
            }
          });
        });
    }

    next();
  }, 500);
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
